import { Pipe, PipeTransform } from '@angular/core';
import { InstallerResponse, MatchedInstaller } from '../../domains/work/matched-installer/matched-installer.model';

@Pipe({ name: 'hasShownInterest' })
export class HasShownInterestPipe implements PipeTransform {
  transform(matchedInstaller: MatchedInstaller): boolean {
    return matchedInstaller?.response === InstallerResponse.Accepted;
  }
}
